export type BagelDocumentDetailTab = 'details' | 'preview';

export function parseBagelDocumentDetailTab(
  hash: string,
): BagelDocumentDetailTab {
  const raw = hash.replace(/^#/, '').trim().toLowerCase();
  if (raw === 'preview') return 'preview';
  return 'details';
}

export function bagelDocumentDetailTabToHash(
  tab: BagelDocumentDetailTab,
): string {
  return tab === 'preview' ? '#preview' : '';
}
